<template>
  <router-view />
</template>

<style lang="scss">
@import "./src/assets/css/landing/landing";
</style>
